// Generated by purs version 0.13.8
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Fuzzy = require("../Data.Fuzzy/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var sortBySearch = function (dictOrd) {
    return function (toString) {
        return function (search) {
            return function (elements) {
                var withMatches = Data_Functor.map(Data_Functor.functorArray)(function (element) {
                    return Data_Tuple.Tuple.create(element)(Data_Fuzzy.matchStr(true)(search)(toString(element)));
                })(elements);
                var sorted = Data_Array.sortBy(function (v) {
                    return function (v1) {
                        return Data_Ord.compare(Data_Fuzzy.ordFuzzyStr)(v.value1)(v1.value1);
                    };
                })(withMatches);
                var $9 = search === "";
                if ($9) {
                    return elements;
                };
                return Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.fst)(sorted);
            };
        };
    };
};
module.exports = {
    sortBySearch: sortBySearch
};
